export default __webpack_public_path__ + "static/media/fad-digital3.7db29ffc.svg";